// extracted by mini-css-extract-plugin
export var addButton = "_e4-4";
export var contentBlockImage = "_e4-i";
export var contentBlockWidgetPreview = "_e4-g";
export var fulfillmentCutoffWidgetPreview = "_e4-9";
export var imageBackdrop = "_e4-6";
export var imageIcon = "_e4-8";
export var lowProfileImageContainer = "_e4-b";
export var lowProfileImageIcon = "_e4-f";
export var lowProfileImageIconContainer = "_e4-e";
export var lowProfileImagePlaceholder = "_e4-d";
export var lowProfileProductImage = "_e4-c";
export var lowProfileProductUpsellWidgetPreview = "_e4-a";
export var productCard = "_e4-5";
export var productImage = "_e4-7";
export var productReviewsWidgetPreview = "_e4-h";
export var progressBar = "_e4-1";
export var progressBarFill = "_e4-2";
export var progressBarTrack = "_e4-3";
export var shippingOptionWidgetPreview = "_e4-j";
export var shippingUpsellProgressBar = "_e4-k";
export var thresholdUpsellWidgetPreview = "_e4-0";